module.exports = __webpack_public_path__ + "24e004ab/img/scraper-icon.df6ccde5.svg";